import React from "react";

import Grid from "@material-ui/core/Grid";

import ImageSlider from '../carousel/ImageSlider';

export default class SliderBuilder {
    static build(cards, pos, dark, userLang, manager, duplicates, maxElements) {
        const single =
            <Grid item xs={12} key={'gridpos' + pos + 'single' + userLang}>
                <ImageSlider
                    cards={cards}
                    duplicates={duplicates}
                    autoPlay={true}
                    userLang={userLang}
                    manager={manager}
                    key={'gridposslider' + pos + 'single' + userLang}
                    keyValue={'gridpossliderca' + pos + 'single' + userLang}
                    maxElements={maxElements}
                    dark={dark}
                />
            </Grid>;
        const double =
            <Grid item xs={6} key={'gridpos' + pos + 'double' + userLang}>
                <ImageSlider
                    cards={cards}
                    duplicates={duplicates}
                    autoPlay={true}
                    userLang={userLang}
                    manager={manager}
                    key={'gridposslider' + pos + 'double' + userLang}
                    keyValue={'gridpossliderca' + pos + 'double' + userLang}
                    maxElements={maxElements}
                    dark={dark}
                />
            </Grid>;
        return [single, double];
    }
}
